import React, { useState } from 'react'
import {
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
    Button,
} from '../../styling/GlobalStyles'
import { useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { RootState } from 'store'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearTransportationUsers, getTransportationUsers } from 'features/transportation/transportationSlice'
import { ITransportationSettingsModalState, TransportationSettingsModal } from './TransportationSettingsModal'
import { IGetAllTransporationUsersSingleResponse } from 'types/api/transportationApi.interface'

export const TransportationEmployees = () => {
    const { users } = useSelector((store: RootState) => store.transportation)
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const [modal, setModal] = useState<{ open: boolean, value: ITransportationSettingsModalState }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getTransportationUsers], cleanUpFunctions: [clearTransportationUsers], params })

    const openModal = (item?: IGetAllTransporationUsersSingleResponse) => {
        setModal({
            open: true, value: {
                direction: item?.transportationSettings?.direction ? transportationDirections.find(d => d.value == item.transportationSettings?.direction) : null,
                user: item?.id ? { value: item.id, label: item.firstName + ' ' + item.lastName } : null,
                transportationZone: item?.transportationSettings?.transportationZone?.id ? { value: item.transportationSettings?.transportationZone?.id, label: item.transportationSettings?.transportationZone?.name } : null
            }
        })
    }

    return (
        <>
            <NavBar defaultValue={params.q} input placeholder='Search Employees...' setParams={setParams} limit={30} />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack arrow title='Employees with transporation' />
                    <Button orange onClick={() => openModal()} >Add Settings</Button>
                </Flex>
                {!users?.data?.length ? (
                    <NoItems title='Employees' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='20%' noTooltip text='NAME' />
                            <Td w='20%' noTooltip text='ZONE' />
                            <Td w='20%' noTooltip text='ADDRESS' />
                            <Td w='35%' noTooltip text='DIRECTION' />
                            <Td w='5%' />
                        </Th>
                        {
                            users.data?.map((item) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td w='20%' text={item.firstName + ' ' + item.lastName} />
                                        <Td w='20%' text={item?.transportationSettings?.transportationZone?.name || '/'} />
                                        <Td w='20%' text={item?.transportationSettings?.transportationZone?.address || '/'} />
                                        <Td w='35%' text={transportationDirections.find(d => d.value == item.transportationSettings?.direction)?.label || '/'} />
                                        <Td options w='5%'>
                                            <Options item={item} openModal={() => openModal(item)} title='Transportation Employees' />
                                        </Td>
                                    </Tr>
                                )
                            })}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(users.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
            {modal.open && <TransportationSettingsModal value={modal.value} closeModal={() => setModal({ open: false, value: null })} />}
        </>
    )
}

export const transportationDirections = [
    { value: 1, label: 'In Bound' },
    { value: 2, label: 'Out Bound' },
    { value: 3, label: 'Both' },
]